<div class="pot-textarea custom-form-control-container">
  <textarea
    class="custom-form-control-input"
    [potAutoResize]="autoResize"
    [value]="value"
    [disabled]="isDisabled"
    [attr.maxlength]="maxLength"
    [placeholder]="placeholder"
    (change)="onChange($event)"
    (keyup)="onChange($event)"
    (blur)="onTouched()"
  >
  </textarea>

  @if (controlDir?.control?.errors && controlDir?.control?.dirty) {
    <div class="pot-custom-form-error-msg">
      @if (controlDir?.control?.errors?.required) {
        <span> This is a required field </span>
      }
    </div>
  }
</div>
